import { UPDATE_TV_MODE } from '../actions'

type State = { tvMode: boolean }

const initialState: State = { tvMode: true }

export default function init (previousState = initialState, { type, payload }: { type: string; payload: boolean }) {
  return type === UPDATE_TV_MODE ? { ...previousState, tvMode: payload } : previousState
}
